export default {
  list: [
    {
      title: 'پرداخت شده',
      value: 'PAID',
    },
    {
      title: 'پرداخت نشده',
      value: 'UNPAID',
    },
  ],
  values: {
    PAID: 'PAID',
    NOTPAID: 'NOTPAID',
  },
};
